import React from 'react';

export default function SimpleConversationHeads({
  styles,
  data,
  onSelect,
  emptyText = 'No conversations yet',
  keyExtractor,
  activeId,
  showAvatars = true,
}) {
  return (
    <div>
      {data && data.length > 0 ? (
        data.map((item, idx) => {
          const lastMsg = item.lastMessage || '';
          const lastTs = item.lastTimestamp ? new Date(item.lastTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
          const heading = item.heading != null && String(item.heading).trim() !== '' ? item.heading : 'New heading';
          let initials = '';
          if (item.chats && item.chats.length > 0 && typeof item.chats[0] === 'string') {
            const parts = item.chats[0].split('@')[0].split('.');
            initials = parts.map(p => p[0]?.toUpperCase() || '').join('').slice(0, 2);
          }
          const isActive = activeId && (item.id === activeId || item.convoId === activeId);
          return (
            <div
              key={keyExtractor ? keyExtractor(item, idx) : String(item?.id || item?.convoId || idx)}
              style={{
                ...styles.headItemWrap,
                background: isActive ? '#e8f0ff' : '#fff',
                borderColor: isActive ? '#0f5bd7' : '#ececec',
                cursor: 'pointer',
              }}
              onClick={() => onSelect(item)}
            >
              <div style={{ ...styles.headTitleBtn, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {showAvatars && (
                  <div style={{ width: 28, height: 28, borderRadius: 14, backgroundColor: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 8 }}>
                    <span style={{ color: '#0f5bd7', fontWeight: 'bold' }}>{initials}</span>
                  </div>
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ ...styles.headTitleText,  fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{heading}</div>
                  <div style={{ fontSize: 11, color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lastMsg}</div>
                </div>
                {lastTs ? <div style={{ fontSize: 10, color: '#999', marginLeft: 6 }}>{lastTs}</div> : null}
              </div>
            </div>
          );
        })
      ) : (
        <div style={styles.emptyHeadsText}>{emptyText}</div>
      )}
    </div>
  );
}
